import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/duty-scheduling")({
  component: Outlet,
  beforeLoad: ({ context: { t } }) => {
    return {
      getTitle: () => t("DutyScheduling"),
    }
  },
})
